import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcCustomBadgeComponent } from './fc-custom-badge.component';

@NgModule({
  entryComponents: [
    FcCustomBadgeComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    FcCustomBadgeComponent
  ],
  exports: [
    FcCustomBadgeComponent
  ]
})
export class FcCustomBadgeModule {}
